import type { ILocationResponse, ILocationResponseV1 } from "./location.interface"
import type { Links } from "@/http"
import type { IZipSummaryResponse, IZipSummaryResponseV1, Media } from "@/models"

export enum PredefinedSortOrder {
  TitleAsc = "TitleAsc",
  TitleDesc = "TitleDesc",
  AlbumDateNewest = "AlbumDateNewest",
  AlbumDateOldest = "AlbumDateOldest",
}

export interface IAlbumSettingsResponse {
  DisableGuestUpload?: boolean
  HideGuestbook?: boolean
  SharePixWithGuests?: boolean
  StreamingAllowed?: boolean
  ShareGuestbookWithGuests?: boolean
  AllowGuestDownload?: boolean
}

export interface IAlbumSettingsResponseV1 {
  disableGuestUpload?: boolean
  hideGuestbook?: boolean
  sharePixWithGuests?: boolean
  streamingAllowed?: boolean
  shareGuestbookWithGuests?: boolean
  allowGuestDownload?: boolean
  allowGuestShare?: boolean
}

export interface IAlbumRequest {
  Title: string
  Description?: string
  IsDefault?: boolean
  AlbumDate?: Date
  IsLocked?: boolean
  IsHidden?: boolean
  CoverImageFile?: File
  AlbumPasscode?: string
}

export interface IAlbumResponse extends IAlbumRequest {
  EventAlbumID: number
  EventVaultID: number
  CoverImageURL: string
  AlbumStatus: number
  AlbumShareLink?: string
  FullPathToQRCode?: string
  AlbumCloseDate?: string
  TotalPhotos?: number
  TotalVideos?: number
  ZipJobSummary?: IZipSummaryResponse
  Location?: ILocationResponse
  AlbumSettings?: IAlbumSettingsResponse
  AccessToken?: string
}

export interface IAlbumRequestV1 {
  title: string
  description?: string | null
  isDefault?: boolean
  albumDate?: Date
  isLocked?: boolean
  isHidden?: boolean
  coverImageFile?: File
  albumPasscode?: string
}

export interface IAlbumResponseV1 extends IAlbumRequestV1 {
  eventAlbumID: number
  eventVaultID: number
  coverImageURL: string
  albumStatus: number
  albumShareLink?: string
  fullPathToQRCode?: string
  albumCloseDate?: string
  totalPhotos?: number
  totalVideos?: number
  accessToken?: string
  displayOrder?: number
  location?: ILocationResponseV1 | null
  albumSettings?: IAlbumSettingsResponseV1
  zipJobSummary?: IZipSummaryResponseV1
}

export interface IAlbumResponseMeta {
  MaxAlbumsAllowed?: number
  TotalAlbumCount?: number
  AlbumPurchaseLink?: string
}

export interface IAlbumResponseMetaV1 {
  maxAlbumsAllowed?: number
  totalAlbumCount?: number
  albumPurchaseLink?: string
}

export interface IAlbumMedia {
  media: Media[]
  links?: Links
  pendingMediaCount?: number
  meta?: {
    totalPhotos?: number
    totalVideos?: number
    pendingMediaCount?: number
    totalAwaitingApproval?: number
  }
}
